import React from 'react';
import { IProductRequestModalContentViewProps } from './lxs-product-request-modal.data';

const ProductRequestModalContentView: React.FC<IProductRequestModalContentViewProps> = ({
    resources,
    onClose,
    soldTos,
    isAuthenticated,
    selectedSoldToId,
    isCompanyDropdownOpen,
    companyDropdownRef,
    form,
    isSubmitting,
    submitError,
    isSubmitted,
    isSubmitDisabled,
    capabilities,
    minSelectableDeliveryDate,
    getCountryDisplayName,
    handleChange,
    handleSoldToSelect,
    openDeliveryDatePicker,
    handleDateChange,
    handleSubmit,
    setIsCompanyDropdownOpen
}) => {
    const CLASS_NAME = 'lxs-product-request-modal';
    return (
        <div className={CLASS_NAME}>
            <div className={`${CLASS_NAME}__panels`}>
                <div className={`${CLASS_NAME}__sidebar`}>
                    <span className={`${CLASS_NAME}__eyebrow`}>{resources.productRequestModalLeftEyebrow}</span>
                    <h3 className={`${CLASS_NAME}__title`}>{resources.productRequestModalLeftHeading}</h3>
                    <p className={`${CLASS_NAME}__sidebar-text`}>{resources.productRequestModalLeftText}</p>
                    <h4 className={`${CLASS_NAME}__sidebar-section-heading`}>{resources.productRequestModalLeftWhySaltigoHeading}</h4>
                    <ul className={`${CLASS_NAME}__bullets`}>
                        <li>{resources.productRequestModalLeftBullet1}</li>
                        <li>{resources.productRequestModalLeftBullet2}</li>
                        <li>{resources.productRequestModalLeftBullet3}</li>
                        <li>{resources.productRequestModalLeftBullet4}</li>
                        <li>{resources.productRequestModalLeftBullet5}</li>
                    </ul>
                </div>

                {isSubmitted ? (
                    <div className={`${CLASS_NAME}__right ${CLASS_NAME}__success`}>
                        <h4 className={`${CLASS_NAME}__form-heading`}>{resources.productRequestModalSuccessHeading}</h4>
                        <p className={`${CLASS_NAME}__form-subheading`}>{resources.productRequestModalSuccessText}</p>
                    </div>
                ) : (
                    <form className={`${CLASS_NAME}__right`} onSubmit={handleSubmit}>
                        <div className={`${CLASS_NAME}__form-intro`}>
                            <h4 className={`${CLASS_NAME}__form-heading`}>{resources.productRequestModalFormHeading}</h4>
                            <p className={`${CLASS_NAME}__form-subheading`}>{resources.productRequestModalFormSubheading}</p>
                        </div>

                        <div className={`${CLASS_NAME}__field`}>
                            <label htmlFor={resources.productRequestModalFieldMolecule} className={`${CLASS_NAME}__label`}>
                                {resources.productRequestModalFieldMolecule}
                            </label>
                            <input
                                id={resources.productRequestModalFieldMolecule}
                                className={`${CLASS_NAME}__input form-control`}
                                type='text'
                                required
                                placeholder={resources.productRequestModalFieldMoleculePlaceholder}
                                value={form.molecule}
                                onChange={handleChange('molecule')}
                            />
                            <span className={`${CLASS_NAME}__helper`}>{resources.productRequestModalFieldMoleculeHelper}</span>
                        </div>

                        <div className={`${CLASS_NAME}__field-row`}>
                            <div className={`${CLASS_NAME}__field`}>
                                <label htmlFor={resources.productRequestModalFieldQuantity} className={`${CLASS_NAME}__label`}>
                                    {resources.productRequestModalFieldQuantity}
                                </label>
                                <input
                                    id={resources.productRequestModalFieldQuantity}
                                    className={`${CLASS_NAME}__input form-control`}
                                    type='text'
                                    required
                                    placeholder={resources.productRequestModalFieldQuantityPlaceholder}
                                    value={form.quantity}
                                    onChange={handleChange('quantity')}
                                />
                                <span className={`${CLASS_NAME}__helper`}>{resources.productRequestModalFieldQuantityHelper}</span>
                            </div>

                            <div className={`${CLASS_NAME}__field`}>
                                <label htmlFor={resources.productRequestModalFieldDeliveryDate} className={`${CLASS_NAME}__label`}>
                                    {resources.productRequestModalFieldDeliveryDate}
                                </label>
                                <fieldset className='msc-form__input-group mb-0'>
                                    <div className='msc-form__input-group-container'>
                                        <div className='datepicker-toggle'>
                                            <span className='datepicker-toggle-button' />
                                            <input
                                                type='date'
                                                className='datepicker-input'
                                                value={form.deliveryDateISO}
                                                min={minSelectableDeliveryDate}
                                                onClick={openDeliveryDatePicker}
                                                onChange={handleDateChange}
                                                id={resources.productRequestModalFieldDeliveryDate}
                                            />
                                        </div>
                                        <input
                                            type='text'
                                            className={`datepicker-text-input ${CLASS_NAME}__input form-control`}
                                            value={form.deliveryDate}
                                            placeholder={resources.productRequestModalFieldDeliveryDatePlaceholder}
                                            readOnly
                                        />
                                    </div>
                                </fieldset>
                                <span className={`${CLASS_NAME}__helper`}>{resources.productRequestModalFieldDeliveryDateHelper}</span>
                            </div>
                        </div>

                        <div className={`${CLASS_NAME}__field`}>
                            <label htmlFor={resources.productRequestModalFieldTargetPrice} className={`${CLASS_NAME}__label`}>
                                {resources.productRequestModalFieldTargetPrice}
                            </label>
                            <input
                                id={resources.productRequestModalFieldTargetPrice}
                                className={`${CLASS_NAME}__input form-control`}
                                type='text'
                                placeholder={resources.productRequestModalFieldTargetPricePlaceholder}
                                value={form.targetPrice}
                                onChange={handleChange('targetPrice')}
                            />
                            <span className={`${CLASS_NAME}__helper`}>{resources.productRequestModalFieldTargetPriceHelper}</span>
                        </div>

                        <div className={`${CLASS_NAME}__field`}>
                            <label htmlFor={resources.productRequestModalFieldAdditionalInfo} className={`${CLASS_NAME}__label`}>
                                {resources.productRequestModalFieldAdditionalInfo}
                            </label>
                            <textarea
                                id={resources.productRequestModalFieldAdditionalInfo}
                                className={`${CLASS_NAME}__input form-control`}
                                rows={4}
                                placeholder={resources.productRequestModalFieldAdditionalInfoPlaceholder}
                                value={form.additionalInfo}
                                onChange={handleChange('additionalInfo')}
                            />
                            <span className={`${CLASS_NAME}__helper`}>{resources.productRequestModalFieldAdditionalInfoHelper}</span>
                        </div>

                        <h4 className={`${CLASS_NAME}__section-heading`}>{resources.productRequestModalContactDetailsHeading}</h4>

                        <div className={`${CLASS_NAME}__field-row`}>
                            <div className={`${CLASS_NAME}__field`}>
                                <label htmlFor={resources.productRequestModalFieldFirstName} className={`${CLASS_NAME}__label`}>
                                    {resources.productRequestModalFieldFirstName}
                                </label>
                                <input
                                    id={resources.productRequestModalFieldFirstName}
                                    className={`${CLASS_NAME}__input form-control`}
                                    type='text'
                                    placeholder={resources.productRequestModalFieldFirstNamePlaceholder}
                                    value={form.firstName}
                                    onChange={handleChange('firstName')}
                                />
                            </div>
                            <div className={`${CLASS_NAME}__field`}>
                                <label htmlFor={resources.productRequestModalFieldLastName} className={`${CLASS_NAME}__label`}>
                                    {resources.productRequestModalFieldLastName}
                                </label>
                                <input
                                    id={resources.productRequestModalFieldLastName}
                                    className={`${CLASS_NAME}__input form-control`}
                                    type='text'
                                    placeholder={resources.productRequestModalFieldLastNamePlaceholder}
                                    value={form.lastName}
                                    onChange={handleChange('lastName')}
                                />
                            </div>
                        </div>

                        <div className={`${CLASS_NAME}__field`}>
                            <label htmlFor={resources.productRequestModalFieldCompany} className={`${CLASS_NAME}__label`}>
                                {resources.productRequestModalFieldCompany}
                            </label>
                            {soldTos && soldTos.length > 0 && isAuthenticated ? (
                                <div className={`${CLASS_NAME}__company-dropdown`} ref={companyDropdownRef}>
                                    <button
                                        type='button'
                                        className={`${CLASS_NAME}__company-trigger`}
                                        onClick={() => setIsCompanyDropdownOpen(prev => !prev)}
                                    >
                                        <span className={`${CLASS_NAME}__company-name`}>{form.company}</span>
                                        {form.country && (
                                            <span className={`${CLASS_NAME}__company-country`}>
                                                ({getCountryDisplayName(form.country)})
                                            </span>
                                        )}
                                    </button>
                                    {isCompanyDropdownOpen && (
                                        <ul className={`${CLASS_NAME}__company-list`} role='listbox'>
                                            {soldTos.map(soldToEntry => (
                                                <li
                                                    key={soldToEntry.Id}
                                                    role='option'
                                                    aria-selected={soldToEntry.Id === selectedSoldToId}
                                                    className={`${CLASS_NAME}__company-option${
                                                        soldToEntry.Id === selectedSoldToId
                                                            ? ` ${CLASS_NAME}__company-option--selected`
                                                            : ''
                                                    }`}
                                                    onClick={() => handleSoldToSelect(soldToEntry)}
                                                >
                                                    <span className={`${CLASS_NAME}__company-name`}>{soldToEntry.Name1}</span>
                                                    {soldToEntry.Country && (
                                                        <span className={`${CLASS_NAME}__company-country`}>
                                                            ({getCountryDisplayName(soldToEntry.Country)})
                                                        </span>
                                                    )}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            ) : (
                                <input
                                    id={resources.productRequestModalFieldCompany}
                                    className={`${CLASS_NAME}__input form-control`}
                                    type='text'
                                    placeholder={resources.productRequestModalFieldCompanyPlaceholder}
                                    value={form.company}
                                    onChange={handleChange('company')}
                                />
                            )}
                        </div>

                        <div className={`${CLASS_NAME}__field`}>
                            <label htmlFor={resources.productRequestModalFieldEmail} className={`${CLASS_NAME}__label`}>
                                {resources.productRequestModalFieldEmail}
                            </label>
                            <input
                                id={resources.productRequestModalFieldEmail}
                                className={`${CLASS_NAME}__input form-control`}
                                type='email'
                                required
                                placeholder={resources.productRequestModalFieldEmailPlaceholder}
                                value={form.email}
                                onChange={handleChange('email')}
                            />
                        </div>

                        <div className={`${CLASS_NAME}__field`}>
                            <label htmlFor={resources.productRequestModalFieldPhone} className={`${CLASS_NAME}__label`}>
                                {resources.productRequestModalFieldPhone}
                            </label>
                            <input
                                id={resources.productRequestModalFieldPhone}
                                className={`${CLASS_NAME}__input form-control`}
                                type='tel'
                                placeholder={resources.productRequestModalFieldPhonePlaceholder}
                                value={form.phone}
                                onChange={handleChange('phone')}
                            />
                        </div>

                        {submitError && <p className={`${CLASS_NAME}__submit-error`}>{submitError}</p>}
                        <div className={`${CLASS_NAME}__actions`}>
                            {onClose && (
                                <button type='button' className='msc-cta__secondary' onClick={onClose} disabled={isSubmitting}>
                                    {resources.productRequestModalCancelButton}
                                </button>
                            )}
                            <button type='submit' className='msc-cta__primary' disabled={isSubmitDisabled}>
                                {isSubmitting ? '...' : resources.productRequestModalSubmitButton}
                            </button>
                        </div>
                    </form>
                )}
            </div>

            <div className={`${CLASS_NAME}__capabilities`}>
                <span className={`${CLASS_NAME}__capabilities-heading`}>{resources.productRequestModalCapabilitiesHeading}</span>
                <div className={`${CLASS_NAME}__capabilities-grid`}>
                    {capabilities.map((capability, index) => (
                        <div key={index} className={`${CLASS_NAME}__capability-item`}>
                            <strong className={`${CLASS_NAME}__capability-title`}>{capability.title}</strong>
                            <p className={`${CLASS_NAME}__capability-text`}>{capability.text}</p>
                            <a
                                className={`${CLASS_NAME}__capability-link`}
                                href={capability.linkUrl}
                                target='_blank'
                                rel='noopener noreferrer'
                            >
                                {capability.linkText}
                            </a>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ProductRequestModalContentView;
